<template>
    <div>
        <section class="mobile_only contact_top_banner cat_in_top_banner cover">
            <div class="container"></div>
            <div class="bn_corner"></div>
        </section>
        <section class="contact_page no_banner_page clearfix">
            <div class="container">
                <div class="contact_main">
                    <h1 class="cat_title">שירות לקוחות</h1>
                    <h2 class="text">
                        <b>אנחנו מקשיבים בכל הערוצים:</b> מייל, טלפון, ווטסאפ -
                        אנחנו פה!
                    </h2>
                    <div class="serv_box clearfix">
                        <div class="right serv_wrap clearfix">
                            <div class="right serv_item">
                                <a
                                    :href="
                                        'tel:' +
                                        [
                                            globalOptions.main_phone
                                                ? globalOptions.main_phone
                                                : '',
                                        ]
                                    "
                                >
                                    <span class="serv_icon ease">
                                        <PHONE />
                                    </span>
                                    <span class="serv_tx">{{
                                        globalOptions.main_phone
                                            ? globalOptions.main_phone
                                            : ""
                                    }}</span>
                                </a>
                            </div>
                            <div
                                class="right serv_item hasTooltip"
                                title="יש להוסיף את המספר לרשימת אנשי הקשר (אפשר לקרוא לנו 'כרמלה') ואז לשלוח לנו הודעה
"
                            >
                                <a
                                    :href="
                                        'https://api.whatsapp.com/send?phone=972' +
                                        globalOptions.whatsapp_phone.replace(
                                            /\D/g,
                                            ''
                                        )
                                    "
                                >
                                    <span class="serv_icon ease">
                                        <WHATSAPP />
                                    </span>
                                    <span class="serv_tx">{{
                                        globalOptions.whatsapp_phone
                                    }}</span>
                                </a>
                            </div>
                            <div class="right serv_item">
                                <a :href="'mailto:' + globalOptions.main_email">
                                    <span class="serv_icon ease">
                                        <MAIL />
                                    </span>
                                    <span class="serv_tx">{{
                                        globalOptions.main_email
                                    }}</span>
                                </a>
                            </div>
                        </div>
                        <div class="left serv_item serv_ques">
                            <router-link
                                :to="{
                                    path: globalOptions.pages.faq.replace(
                                        wpData.home_url,
                                        ''
                                    ),
                                }"
                            >
                                <span class="serv_icon ease">
                                    <Question />
                                </span>
                                <span class="serv_tx">
                                    תשובות לשאלות נפוצות אפשר למצוא
                                    <a-div
                                        class="serv_link"
                                        :href="
                                            pageData.acf.faq_link
                                                ? pageData.acf.faq_link.replace(
                                                      wpData.home_url,
                                                      ''
                                                  )
                                                : ''
                                        "
                                        >כאן</a-div
                                    >
                                </span>
                            </router-link>
                        </div>
                    </div>
                    <hr />
                    <div class="form_before">
                        <h2 class="text">
                            <b>ואפשר להשאיר לנו פה מילה:</b>
                        </h2>
                        <div class="contact_form" v-html="contactForm"></div>
                    </div>
                    <div class="form_thank" style="display: none">
                        <div class="ok-thank">
                            <OK />
                        </div>
                        <b>ההודעה נשלחה!</b>
                        <br />ניצור איתך קשר בהקדם
                    </div>
                </div>
            </div>
            <div class="contact_side"></div>
        </section>

        <SaveCartForService />
    </div>
</template>

<script>
    import PHONE from "../assets/img/phone.svg";
    import WHATSAPP from "../assets/img/whatsapp.svg";
    import OK from "../assets/img/ok.svg";
    import MAIL from "../assets/img/mail.svg";
    import Question from "../assets/img/question.svg";
    import SaveCartForService from "../components/Home/SaveCartForService.vue";
    export default {
        data() {
            return {
                //wpData: wpData,
                //  contactForm: wpData.contact_form,
                //globalOptions: wpData.globalOptions,
                title: "",
                content: "",
                mailOk: false,
                // pageData: JSON.parse(wpData.pageData)
            };
        },
        computed: {
            wpData() {
                return wpData;
            },
            globalOptions() {
                return wpData.globalOptions;
            },
            contactForm() {
                return wpData.contact_form;
            },
            pageData() {
                if (typeof wpData.pageData == "object") {
                    return wpData.pageData;
                }
                return JSON.parse(wpData.pageData);
            },
        },
        watch: {
            $route(to, form) {
                setTimeout(() => {
                    // wpcf7.initForm(jQuery(".wpcf7-form"));
                    //console.log("loaded 2");
                    document.addEventListener(
                        "wpcf7mailsent",
                        function (event) {
                            if (
                                event.detail.apiResponse.status == "mail_sent"
                            ) {
                                var $form =
                                    document.querySelector(".form_before");
                                var $thank =
                                    document.querySelector(".form_thank");
                                $form.setAttribute("style", "display: none");
                                $thank.setAttribute("style", "display:block");
                            }
                        }
                    );
                }, 2000);
            },
        },
        mounted: function () {
            //wpcf7.initForm(jQuery(".wpcf7-form"));
            setTimeout(() => {
                // wpcf7.initForm(jQuery(".wpcf7-form"));

                $(".wpcf7-form .submit_bt input").on("click", function (e) {
                    $(".wpcf7-form .submit_bt").addClass("proccessing");
                });
                $(".wpcf7").on("wpcf7invalid", function (e) {
                    $(".wpcf7-form .submit_bt").removeClass("proccessing");
                });
                $(".wpcf7").on("wpcf7submit", function (e) {
                    $(".wpcf7-form .submit_bt").removeClass("proccessing");
                });

                document.addEventListener("wpcf7mailsent", function (event) {
                    if (event.detail.apiResponse.status == "mail_sent") {
                        var $form = document.querySelector(".form_before");
                        var $thank = document.querySelector(".form_thank");
                        $form.setAttribute("style", "display: none");
                        $thank.setAttribute("style", "display:block");
                        var submit = document.querySelector(".submit_bt");
                        submit.classList.remove("proccessing");
                        $(".submit_bt").removeClass("proccessing");
                    }
                });
            }, 2000);
        },
        methods: {
            mailSent() {
                this.mailOk = true;
            },
        },

        components: {
            PHONE,
            WHATSAPP,
            OK,
            MAIL,
            Question,
            SaveCartForService,
        },
    };
</script>
